import { useState } from "react";
import useAuth from "$hooks/useAuth";
import { ProjectServices } from "$services";

const useProjectForm = (postSubmitAction?: any, externalTogglePopin?: any) => {
  const { token } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [isOpened, setOpen] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [project, setProject] = useState<any>(null);

  const openPopin = async (projectId?: string) => {
    if (projectId) {
      const projectData = await ProjectServices.GetProject(token, projectId);
      setProject(projectData);
    } else {
      setProject(null);
    }
    setOpen(true);
  };

  const togglePopin = (isOpen: boolean) => {
    if (!isOpen) {
      setError("");
      setProject(null);
    }
    setOpen(isOpen);
  };

  const handleSubmit = async (data: any) => {
    setSubmitting(true);
    const Service = data._id
      ? ProjectServices.UpdateProject
      : ProjectServices.AddProject;

    try {
      const body = await Service(token, data, data._id);

      if (body?.error) {
        setError(body.error);
      } else {
        togglePopin(false);
        externalTogglePopin?.();
        setError("");
        postSubmitAction?.();
      }
      return body;
    } catch (err: any) {
      setError(err.error || err.message || "Erreur Serveur");
    } finally {
      setSubmitting(false);
    }
  };

  return {
    error,
    handleSubmit,
    isOpened,
    openPopin,
    project,
    submitting,
    togglePopin,
  };
};

export default useProjectForm;
